<div class="container-fluid p-4 h-100 overflow-auto">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div><h4 class="mb-0 text-secondary">Compliance</h4></div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    @if(canFilterBySupplier) {
                        <dx-tag-box
                            [dataSource]="supplierDataSource"
                            valueExpr="id"
                            displayExpr="name"
                            [(value)]="selectedSuppliers"
                            [showSelectionControls]="true"
                            selectAllMode="allPages"
                            [searchEnabled]="true"
                            [showClearButton]="true"
                            [maxDisplayedTags]="1"
                            [multiline]="false"
                            placeholder="All Suppliers"
                            stylingMode="filled"
                            [width]="240"
                            (onValueChanged)="onFiltersChanged()"
                        ></dx-tag-box>
                    }
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="true"
                        [(value)]="dateRangeFilterValue"
                        stylingMode="filled"
                        (onValueChanged)="onDateRangeChanged()"
                    ></dx-date-range-box>
                    <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                </div>
            </div>

            <div class="row align-items-center mb-4">
                <div class="col-sm-8 text-center position-relative">
                    <div class="d-flex align-items-center justify-content-center mb-3">
                        <dx-pie-chart
                            type="doughnut"
                            [dataSource]="scoreRingData"
                            [innerRadius]="0.7"
                            centerTemplate="centerTemplate"
                            [customizePoint]="customizeScoreRingPoint"
                        >
                            <dxo-pie-chart-size [height]="300"></dxo-pie-chart-size>
                            <dxi-series argumentField="argument" valueField="value">
                                <dxo-label [visible]="false"></dxo-label>
                            </dxi-series>
                            <dxo-tooltip [enabled]="false"></dxo-tooltip>
                            <dxo-legend [visible]="false"></dxo-legend>
                            <svg *dxTemplate="let pieChart of 'centerTemplate'">
                                <text text-anchor="middle" style="font-size: 40px; fill: currentColor;" x="100" y="120">
                                    <tspan x="100" dy="0">{{ centerLabel }}</tspan>
                                    <tspan
                                        class="text-body-secondary"
                                        x="100" dy="20"
                                        style="font-size: 14px; fill: currentColor;">My Score
                                    </tspan>
                                </text>
                            </svg>
                        </dx-pie-chart>
                    </div>
                    <div class="d-flex justify-content-center">
                        <span class="d-inline-flex align-items-center">
                            <span class="rounded-circle me-1" style="width: 14px; height: 14px; background: var(--bs-primary);"></span>
                            <small class="text-body-secondary">Compliance %</small>
                        </span>
                    </div>
                </div>

                <div class="col-sm-4 col-xl-3 offset-xl-1">
                    <div class="table-responsive rounded-1 border border-1">
                        <table class="table table-borderless mb-0">
                            <thead class="bg-light text-muted small text-uppercase">
                            <tr class="table-light">
                                <th>Type</th>
                                <th>Instances</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (detail of scoreDetails; track detail.argument) {
                                    <tr class="border-top">
                                        <td class="text-muted">{{ detail.argument }}</td>
                                        <td class="text-muted">{{ detail.value | number:'1.0-2' }}{{ detail.argument === 'Compliance %' ? '%' : '' }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="mb-0 text-secondary">My Score Trending</h4>
                </div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-select-box
                        [items]="trendingFilterOptions"
                        [(value)]="trendingFilterValue"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled"
                    >
                    </dx-select-box>
                </div>
            </div>

            <div class="mb-5">
                @for (key of [trendingKey]; track key) {
                    <app-trending
                        [aggregateType]="trendingFilterValue"
                        [loadData]="loadTrendingData"
                        [formatMode]="'percent'"
                    ></app-trending>
                }
            </div>
        </div>
    </div>

    @if(canSeeSupplierCompliance)
    {
        <div class="card border-0 shadow-sm mb-5">
            <div class="card-body">
                <h4 class="mb-4 text-secondary">Supplier Compliance</h4>
                <dx-chart [dataSource]="supplierBars" [rotated]="false">
                    <dxi-series argumentField="argument" valueField="value" type="bar" [barPadding]="0.3"></dxi-series>
                    <dxi-value-axis [visible]="true" title="Percent %">
                        <dxo-label [format]="{ type: 'fixedPoint', precision: 0 }"></dxo-label>
                    </dxi-value-axis>
                    <dxo-argument-axis>
                        <dxo-label [visible]="true" overlappingBehavior="rotate" [rotationAngle]="-45"></dxo-label>
                    </dxo-argument-axis>
                    <dxo-legend [visible]="false"></dxo-legend>
                    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeSupplierTooltip"></dxo-tooltip>
                </dx-chart>
            </div>
        </div>
    }
</div>
